import React, { useCallback } from 'react'

import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { contentManagementActions, contentManagementSelectors } from 'apps/cms/store'
import { isExternalFlowOrigin } from 'common/flow/flowOrigin'

import { ClassicFlowCard } from './ClassicFlowCard'
import { ExternalFlowCard } from './ExternalFlowCard'

interface FlowCardProps {
  flowId: string
  allowSelect: boolean
}

export const FlowCard = React.memo(function FlowCard({ flowId, allowSelect }: FlowCardProps) {
  const dispatch = useAppDispatch()
  const flow = useAppSelector(contentManagementSelectors.getFlows).find(
    (item) => item.ns === flowId,
  )
  const isFlowSelected = useAppSelector((state) =>
    contentManagementSelectors.getIsFlowSelected(state, flowId),
  )

  const handleToggleFlowSelection = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const shiftIsPressed = 'shiftKey' in event.nativeEvent && event.nativeEvent.shiftKey

      if (shiftIsPressed) {
        dispatch(contentManagementActions.selectFlowsInRange(flowId))
        return
      }

      dispatch(contentManagementActions.toggleFlowSelection(flowId))
    },
    [dispatch, flowId],
  )

  if (!flow) {
    return null
  }

  return isExternalFlowOrigin(flow.origin) ? (
    <ExternalFlowCard
      flow={flow}
      allowSelect={allowSelect}
      isFlowSelected={isFlowSelected}
      onToggleFlowSelection={handleToggleFlowSelection}
    />
  ) : (
    <ClassicFlowCard
      flow={flow}
      allowSelect={allowSelect}
      isFlowSelected={isFlowSelected}
      onToggleFlowSelection={handleToggleFlowSelection}
    />
  )
})
